import Konva from 'konva/konva'
import TitleLabel from './title-label'
import { translateVariableName } from '../../helpers/translation'

export default class TitleLayer extends Konva.Layer {
  constructor ({ name }) {
    super({ name })
  }

  init ({ titleData }) {
    Object.assign(this, { titleData })

    this._render()
  }

  _render () {
    this.destroyChildren()

    this.titleData.forEach(values => this._renderTitle(values))

    this.draw()
  }

  _renderTitle (values) {
    const { asset, variable, error, variableConfig, yOffset } = values

    if (error)
       return this._addTitle(TitleLayer._createError(error, yOffset))

    if (variable)
      return this._addTitle(TitleLayer._createVariableTitle(variable, variableConfig, yOffset, asset))

    if (asset)
      return this._addTitle(TitleLayer._createAssetTitle(asset, yOffset))
  }

  _addTitle (title) {
    title.render(title)
    this.add(title)
  }

  static _createAssetTitle (asset, yOffset) {
    return new TitleLabel({
      yOffset,
      title: asset.fullPath || asset.name,
      asset: true
    })
  }

  static _createVariableTitle (variable, variableConfig, yOffset, asset) {
    const transformation = asset.variablesTransformations ? asset.variablesTransformations[variableConfig.name] : ''
    const variableName = transformation || transformation.length > 0 ? transformation : variableConfig.name
    const title = translateVariableName(variableName)
    return new TitleLabel({
      height: variable.height,
      yOffset,
      title
    })
  }

  static _createError (error, yOffset) {
    return new TitleLabel({
      yOffset,
      title: error,
      options: {
        background: 'rgba(255, 0, 0, 0.2)'
      }
    })
  }
}
